import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';

import ModuleLink from './ModuleLink';
import UserContextMenu from './UserContextMenu';
import config from '../../../config/dxconfig';
import { t } from '../../locale';
import tracking from '../../utils/tracking';
import { changelogStorage } from '../../utils/changelogStorage';
import _ from 'lodash';

const Spacer = () => <li>&nbsp;</li>;

class ModuleList extends Component<any, any> {
    [key: string]: any;
    static [key: string]: any;
    static propTypes = {
        modules: PropTypes.arrayOf(PropTypes.shape({})),
        tooltip: PropTypes.bool,
        partnerId: PropTypes.number,
        renterId: PropTypes.number,
        onClickLink: PropTypes.func.isRequired,
        userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // undefined before auth loads
        isOutdated: PropTypes.bool,
    };

    static defaultProps = {
        modules: [],
        tooltip: true,
        isOutdated: false,
    };

    state = {
        changelogHasUnread: false,
    };

    componentDidMount() {
        this.fetchChangelogLatest();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId) {
            this.fetchChangelogLatest();
        }
    }

    fetchChangelogLatest() {
        const { userId } = this.props;
        if (!userId) return;

        axios
            .get('/api/v1/changelog/latest')
            .then(res => {
                const lastEditedAt = res.data?.lastEditedAt;
                if (!lastEditedAt) return;

                return changelogStorage.getLastReadAt(userId).then(lastReadAt => {
                    const hasUnread = !lastReadAt || new Date(lastEditedAt) > new Date(lastReadAt);
                    this.setState({ changelogHasUnread: hasUnread });
                });
            })
            .catch(() => {});
    }

    changeLogClicked = () => {
        const { userId } = this.props;
        const now = new Date().toISOString();
        if (userId) {
            changelogStorage.setLastReadAt(userId, now).then(() => {
                this.setState({ changelogHasUnread: false });
            });
        } else {
            this.setState({ changelogHasUnread: false });
        }
        tracking.track('changelog_opened');
    };

    render() {
        return (
            <div className="partner">
                <ul className="nav nav-pills nav-stacked">
                    <UserContextMenu />
                    <ModuleLink
                        id="changelog-link"
                        url={config.external_urls.changelog}
                        label={t('Oppdateringer')}
                        icon="info-circle"
                        aHrefLink
                        target="_blank"
                        rel="noopener noreferrer"
                        tooltip={this.props.tooltip}
                        onClickLink={this.props.onClickLink}
                        onClick={_.once(this.changeLogClicked)}
                        hasUnread={this.state.changelogHasUnread}
                    />
                    <Spacer />
                    {this.props.modules.map((module, key) =>
                        module.type === 'spacer' ? (
                            <Spacer key={'spacer' + key} />
                        ) : (
                            <ModuleLink
                                partnerId={this.props.partnerId}
                                renterId={this.props.renterId}
                                {...module}
                                key={module.url}
                                tooltip={this.props.tooltip}
                                onClickLink={this.props.onClickLink}
                                isOutdated={this.props.isOutdated}
                            />
                        )
                    )}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const id = state.auth?.user?.id;
    return {
        userId: id === false || id === null || id === undefined ? undefined : id,
    };
};

export default connect(mapStateToProps)(ModuleList);
